import React, { useContext } from "react";
import { FormControl, FormControlLabel, Grid, Switch, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import DurationTimes from "../ticketFlightLegs/durationTimes";
import { DefinitelyAnArray, sortFlightLegsByTime } from "../../sharedCode/HelperMethods";
import { rowMargin, TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { UpDownTimeOnEachLeg } from "../../sharedCode/TimeCalculator";
import { GlobalContext } from "../../Utils/Contexts";
import { SaveUpDownTimesMode } from "../inputs/inputHelpers";
import { saveTicketChanges } from "../../Utils/TicketDatabase";
import Button from "@mui/material/Button";

export default function Header(props: TicketProps): JSX.Element {
    const theme = useTheme();
    const context = useContext(GlobalContext);

    const upDownRequired = UpDownTimeOnEachLeg(props.ticket);

    let needsToSort = false;
    if (upDownRequired) {
        const ticketLocations = DefinitelyAnArray(props.ticket.Locations);
        const sortedLocations = ticketLocations.slice().sort(sortFlightLegsByTime);
        needsToSort = sortedLocations.reduce((result, sortedRow, index) => {
            return result || sortedRow.id !== ticketLocations[index].id;
        }, false);
    }

    // TODO refactor this into two components
    return (
        <>
            <Grid container>
                <Grid item container xs={8} sm={6} alignItems={"center"} justifyContent={"left"}>
                    <Typography>ENTER TIMES PER:&nbsp;&nbsp;&nbsp;&nbsp;TICKET</Typography>
                    <FormControl sx={{ marginLeft: 1 }}>
                        <FormControlLabel control={<Switch checked={upDownRequired} color={"secondary"} onChange={handleModeSwitch} disabled={props.isReadOnly} />} label="LEG" />
                    </FormControl>
                </Grid>
                {!upDownRequired && <DurationTimes {...props} />}
                {upDownRequired && needsToSort && (
                    <Grid item container xs={4} sm={6} alignItems={"center"} justifyContent={"right"}>
                        <Button variant={"contained"} onClick={handleSort}>
                            SORT BY UP TIME
                        </Button>
                    </Grid>
                )}
            </Grid>
            <Grid container item alignItems={"center"} spacing={1} sx={{ marginTop: rowMargin }}>
                <FormControl fullWidth sx={{ marginLeft: 1, borderTop: `1px solid ${theme.palette.divider}` }} />
            </Grid>
        </>
    );

    function handleSort() {
        const sortedLocations = DefinitelyAnArray(props.ticket.Locations).slice().sort(sortFlightLegsByTime);
        saveTicketChanges(props.ticket.id, { Locations: sortedLocations }).catch(() => props.showForceReloadDialogue());
    }

    function handleModeSwitch() {
        // clear all the time related data when the ticket style changes
        const newList = DefinitelyAnArray(props.ticket.Locations).map((location) => ({
            ...location,
            up_time: null,
            down_time: null,
            inputHours: "",
            hours: null,
        }));

        const upDownRequired = props.ticket.up_down_required === 1 ? 0 : 1;

        SaveUpDownTimesMode(upDownRequired);

        saveTicketChanges(props.ticket.id, {
            up_down_required: upDownRequired,
            Locations: newList,
            up_time: undefined,
            down_time: undefined,
        }).catch(() => props.showForceReloadDialogue());
    }
}
